'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

function stubString() {
    return '';
}

exports.stubString = stubString;
